import { Component, OnInit } from '@angular/core';
import { ServerTokenService } from '../../services/server-token.service';
import { User } from '../../models/user';
import { PCC_STEPS, PCC_TASK_CREATE_API_BASE, PCC_TASK_SUB_TYPE, PCCTask } from 'list-types-public';

interface ExpandUser extends User {
  meta?: {
    "pcc"?: {
      PW?: string;
      User?: string;
    }
  },
  message?: string,
  checkLoginStatus?: string
}

@Component({
  selector: 'ngx-move-meta-to-extra',
  templateUrl: './move-meta-to-extra.component.html',
  styleUrls: ['./move-meta-to-extra.component.scss']
})
export class MoveMetaToExtraComponent implements OnInit {

  constructor(private server: ServerTokenService) { }

  users: ExpandUser[];

  ngOnInit(): void {
    this.getAllUsersList();

  }

  async getAllUsersList() {
    const res = await this.server.postWithToken<ExpandUser[]>('sadmin/getAllUserWithExtras', {}).toPromise();
    console.log('getAllUsersList', res);
    this.users = res.filter(user => user.meta?.pcc?.PW && user.meta?.pcc?.User);
  }

  async saveMetaAsExtra(user: ExpandUser) {
    const { _id, meta } = user;
    const { PW, User } = meta?.pcc;
    // type, password, username, userId
    const res = await this.server.postWithToken('code/saveCode', { type: 'PCC', password: PW, username: User, userId: _id }).toPromise();
    console.log('Response', res);

    // this.submitDisabled = true;
    // this.setMeassage("Saving credentials...", 'black');
    if (res) {
      // this.onSubmit.emit(true);
      // this.stateSuccess = true;
      const body: PCC_TASK_CREATE_API_BASE = {
        subType: PCC_TASK_SUB_TYPE.checkCredential,
        data: {},
        type: "pushToPcc"
      }
      const userQuery = { _id, path: '/api/snfs/pccPushTask', body, method: 'POST' };
      // note this is qiery from server masked user
      const task: PCCTask = (await this.server.postWithToken<PCCTask>('sadmin/doQueryForOtherUsers', userQuery).toPromise()).data;
      const interval = setInterval(async () => {
        const currentTask = await this.server.getWithToken<PCCTask>(`snfs/pccGetTask/${task._id}`).toPromise();
        if (currentTask.status == 'start') {
          user.message = "Validating";
        } else if (currentTask.status == 'done') {
          user.message = 'Done'
          clearInterval(interval);
        } else if (currentTask.status == 'error') {
          clearInterval(interval);
          user.message = currentTask.currentStep;
        }
        console.log('Current task', currentTask);
        return task;
      }, 1000);

    }
  }
}
